/* 
Copyright© Celligence International, LLC - 2024
This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import DefaultModal from './DefaultModal';
import Styles from '../../css/modals/LoginModal.module.css';
import { OTPMethod, useLoginContext } from '../../contexts/LoginContext';
import { Button } from '@mui/material';
import { useMemo } from 'react';
import { useAuthContext } from '../../contexts/AuthContext';

const LoginModal = () => {
  const loginContext = useLoginContext();
  const { phoneNo } = useAuthContext();
  const authMethod = loginContext.authenticationMethod;

  const infoMessage = useMemo(() => {
    if (authMethod == OTPMethod.PHONE) {
      return (
        'A One-Time Pin (OTP) was sent to your phone number: ' +
        '(***)-***-**' +
        phoneNo.slice(-2) +
        '. Please check and enter it below, or click "Resend" to obtain another one.'
      );
    } else if (authMethod == OTPMethod.EMAIL) {
      return (
        'A One-Time Pin (OTP) was sent to your email address: ' +
        loginContext.hiddenEmailAddress +
        '. Please check and enter it below, or click "Resend" to obtain another one.'
      );
    }
  }, [authMethod, phoneNo, loginContext.hiddenEmailAddress]);

  return (
    <DefaultModal
      open={loginContext.loginModalOpen}
      title={''}
      content={
        <form className={Styles.container}>
          <p className={Styles.boldText}>{infoMessage}</p>
          <input
            className={loginContext.otpError ? Styles.otpInputError : Styles.otpInput}
            value={loginContext.otp}
            onChange={(e) => loginContext.setOtp(e.target.value)}
            type='text'
            inputMode='numeric'
            placeholder='000000'
            pattern='[0-9]'
            maxLength={6}
          />
          {loginContext.otpError && <p className={Styles.errorText}>Invalid One-Time Pin</p>}
        </form>
      }
      footer={
        <div className={Styles.footer}>
          <Button className={Styles.button} onClick={() => loginContext.sendOTP()}>
            Resend
          </Button>
          <Button className={Styles.button} onClick={loginContext.doLogin}>
            Validate
          </Button>
        </div>
      }
    />
  );
};

export default LoginModal;
